import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { PaymentMethod, PaymentMethodCreate, PaymentMethodFilter } from '../data/paymentMethod';

export function createPaymentMethodService(client: AxiosInstance) {
  return createCrudService<PaymentMethod, PaymentMethodCreate, PaymentMethodFilter>(
    client,
    '/tenancy/PaymentMethod',
    'id',
  );
}

export type PaymentMethodService = CrudService<PaymentMethod, PaymentMethodCreate, PaymentMethodFilter>;
